import React from 'react';
import './toggle.css';

export const Toggle = ({ onChange, value, children }) => {
    return (
        <div className="prism-toggle">
            <div>
                {children.map(c => {
                    return (
                        <button
                            key={c.props.value}
                            className={`prism-toggle-button ${value === c.props.value ? 'active' : ''}`}
                            onClick={() => onChange(c.props.value)}
                        >
                            {c.props.children}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default Toggle;
